<div [style.font-size.px]="direction === 'horizontal' ? 22 : 30" style="padding-left: 0.3em; justify-content: center; height: 100%; display: flex; text-align: center; flex-direction: column">
  <div>{{forecast.date | date: 'E' : 'CET' : 'nl-NL' }}</div>
  <div [style.font-size.px]="direction === 'horizontal' ? 15 : 18" style="text-align: center;">
    {{forecast.date | date: 'd-M' : 'CET' : 'nl-NL'}}
  </div>
</div>
